import { RetrieveRulesPayload, RuleStatuses } from 'app/modules/rules/models';
import { RuleSearchPayload } from 'app/modules/search/payload';
import { ValidationAlertsPayload } from 'app/modules/detectionModels/models';
import { AllowlistedEntitiesPayload } from 'app/modules/rules/queries/useGetSilencedEntities';
import { GlobalAllowlistedEntitiesPayload } from 'app/modules/rules/queries/useGetGlobalSilencedEntities';
import { PaginationPayload } from 'app/shared/pagination/models';

const BASE = ['rules'] as const;

export const RULE_QUERY_KEYS = {
  getRule: (ruleId: number, ruleStatus: RuleStatuses) =>
    [...BASE, 'rule', ruleId, ruleStatus] as const,
  getRulesList: () => [...BASE, 'rules-list'] as const,
  getRules: (payload: RetrieveRulesPayload) =>
    [...RULE_QUERY_KEYS.getRulesList(), payload] as const,
  getRuleSearch: (payload?: RuleSearchPayload) =>
    payload ? ([...BASE, 'search', payload] as const) : [...BASE, 'search'],
  getRuleValidationAlerts: (payload: ValidationAlertsPayload) =>
    [...BASE, 'validation-alerts', payload] as const,
  getAllowlistedEntitiesAll: (ruleId: number) =>
    [...BASE, 'allowlisted-entities', ruleId] as const,
  getAllowlistedEntities: (
    ruleId: number,
    payload: AllowlistedEntitiesPayload,
  ) => [...RULE_QUERY_KEYS.getAllowlistedEntitiesAll(ruleId), payload] as const,
  getGlobalAllowlistedEntitiesAll: () =>
    [...BASE, 'global-allowlisted-entities'] as const,
  getGlobalAllowlistedEntities: (payload: GlobalAllowlistedEntitiesPayload) =>
    [...RULE_QUERY_KEYS.getGlobalAllowlistedEntitiesAll(), payload] as const,
  getAllowlistedInstrumentsAll: (ruleId: number) =>
    [...BASE, 'allowlisted-instruments', ruleId] as const,
  getAllowlistedInstruments: (ruleId: number, payload: PaginationPayload) =>
    [...RULE_QUERY_KEYS.getAllowlistedInstrumentsAll(ruleId), payload] as const,
  getGlobalSilencedInstrumentsAll: () =>
    [...BASE, 'global-silenced-instruments'] as const,
  getGlobalSilencedInstruments: (payload: PaginationPayload) =>
    [...RULE_QUERY_KEYS.getGlobalSilencedInstrumentsAll(), payload] as const,
};
